module.exports = __webpack_public_path__ + "img/cancelled-upArrow.cc83d091.svg";